module.exports = __webpack_public_path__ + "static/knowledgeable-4eff1b96a763548aea076d74084acb5b.svg";